const CDN_BASE_URL = (process.env.REACT_APP_IMAGE_URL || "").trim();

export const getCdnImageUrl = (path = "") => {
  const value = String(path || "").trim();

  if (!value) {
    return "";
  }

  // Keep fully-qualified, data, and blob URLs unchanged.
  if (/^(?:[a-z]+:)?\/\//i.test(value) || value.startsWith("data:") || value.startsWith("blob:")) {
    return value;
  }

  const base = CDN_BASE_URL.endsWith("/")
    ? CDN_BASE_URL.slice(0, -1)
    : CDN_BASE_URL;
  const normalizedPath = value.startsWith("/") ? value.slice(1) : value;

  return base ? `${base}/${normalizedPath}` : normalizedPath;
};
